<template>
  <ShortcutWrapper :nShortcutRequiredClaim="UserClaims.GlobalAdmin" @n-shortcut="createTag">
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-row>
            <v-col style="max-width: 800px;">
              <DataTable
              :loading="loading"
              :items="tags"
              :headers="headers"
              :customCells="customCells">

                <template #actions="{ item }">
                  <Icon
                  icon="mdi-pencil"
                  iconColor="success"
                  :tooltipText="$t('edit')"
                  @icon-clicked="editTag(item)"
                  :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
                  elementId="access-tag-edit"/>
                </template>

                <template #custom-controls>
                  <Icon
                  icon="mdi-refresh"
                  :tooltipText="$t('refresh')"
                  @icon-clicked="refreshTags"
                  :small="false"/>
                  <Icon
                  icon="mdi-plus"
                  :tooltipText="$t('new')"
                  @icon-clicked="createTag"
                  :small="false"
                  :disabled="!userAssignedClaim(UserClaims.GlobalAdmin)"
                  elementId="access-tag-create"/>
                </template>

              </DataTable>

              <v-dialog v-model="formDialog" width="600px">
                <TagForm
                v-if="formDialog"
                :propTag="focusedTag"
                :propTagArea="tagArea"
                @tag-mutated="refreshTags"
                @close="formDialog = false"/>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </ShortcutWrapper>
</template>

<script>
import { mapActions } from 'vuex'
import { tagHeaders } from '@/headers/Tags.js'
import { TagArea, UserClaims } from '@/utils/Enumerations.js'
import { userAssignedClaim } from '@/utils/ClaimUtility'

export default {
  name: 'AccessTagSettings',

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    ShortcutWrapper: () => import('@/components/core/ShortcutWrapper.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    TagForm: () => import('@/components/account/account-tags/TagForm.vue')
  },

  data: () => ({
    formDialog: false,
    tags: [],
    focusedTag: undefined,
    loading: false,
    tagArea: TagArea.LoggingAccessibility,
    UserClaims
  }),

  computed: {
    headers () {
      return tagHeaders(this.$i18n.locale)
    },

    customCells () {
      return [
        {
          slotName: 'actions',
          value: 'actions'
        }
      ]
    }
  },

  created () {
    this.refreshTags()
  },

  methods: {
    ...mapActions('tags', ['fetchTags']),
    userAssignedClaim,

    async refreshTags () {
      this.formDialog = false
      this.loading = true
      try {
        this.tags = await this.fetchTags(this.tagArea.value)
      } finally {
        this.loading = false
      }
    },

    editTag (tag) {
      this.focusedTag = tag
      this.formDialog = true
    },

    createTag () {
      this.focusedTag = undefined
      this.formDialog = true
    }
  }
}
</script>
